import axios from 'axios'
import { getAuthToken } from './TokenUtility'
const baseURL = process.env.NODE_ENV === 'production'
  ? 'https://dev-admin.tribe.sn'
  : '';

const internalApi = axios.create({ baseURL });
internalApi.interceptors.request.use((config: any) => {
  const token = getAuthToken()
  if (token) {
    config = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      },
    }
  }
  return config
})
export default internalApi
